export default __webpack_public_path__ + "static/video-d84eb5d59ae47b769e7ef0824c1e47cf.jpg";